// extracted by mini-css-extract-plugin
module.exports = {"label":"ImageInput_label__xs0dh","tooltip":"ImageInput_tooltip__2WEoB","wrap":"ImageInput_wrap__1Huv0","input":"ImageInput_input__3og14","box":"ImageInput_box__3NQam"};